import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, inject } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { WarehousingWorkHistory } from '../warehousing.model';
import { WarehousingService } from '../warehousing.service';
import { PageFormSectionComponent } from '../../shared/page-layout/page-form-section.component';
import { warehouseWorkMethodLabel } from './warehousing-work-method';

@Component({
  selector: 'app-warehousing-work-history',
  standalone: true,
  imports: [CommonModule, TableModule, TagModule, PageFormSectionComponent],
  templateUrl: './warehousing-work-history.component.html',
  styleUrl: './warehousing-work-history.component.css'
})
export class WarehousingWorkHistoryComponent implements OnChanges {
  methodLabel = warehouseWorkMethodLabel;
  @Input() documentType!: 'TRANSFER' | 'DISPATCH';
  @Input() documentId?: number;
  rows: WarehousingWorkHistory[] = [];
  private service = inject(WarehousingService);

  ngOnChanges(): void {
    if (!this.documentId || !this.documentType) return;
    this.service.getShipmentWorkHistory(this.documentType, this.documentId).subscribe({
      next: response => this.rows = response.data || [],
      error: () => this.rows = []
    });
  }
}
